import React from 'react';
import { Card, Typography } from 'antd';
import { greyScaleTokens } from '../../../theme/theme';

const { Title, Paragraph } = Typography;

/**
 * Componente tutorial riutilizzabile per gli step della creazione catalogo.
 * Props:
 *  - title: Titolo del tutorial
 *  - description: Descrizione/tutorial testuale
 *  - children: (opzionale) elementi aggiuntivi (tips, immagini, ecc)
 */
const Tutorial = ({ title, description, children }) => (
  <Card
    style={{
      position: 'sticky',
      top: 0,
      height: 'fit-content',
      maxHeight: '100vh',
      boxShadow: 'none',
      background: greyScaleTokens.grey100,
      overflowY: 'hidden',
      zIndex: 1,
      paddingBottom: 24 // extra space for scroll
    }}
  >
    <Title level={3} style={{ marginBottom: 16 }}>{title}</Title>
    <Paragraph style={{ fontSize: 16 }}>{description}</Paragraph>
    {children}
  </Card>
);

export default Tutorial;
